export default function ScoreRing({ value = 0, label, size = 110 }) {
  const v = Math.max(0, Math.min(100, value || 0));
  const r = (size - 10) / 2;
  const c = 2 * Math.PI * r;
  const offset = c - (v / 100) * c;
  // Premium accent palette
  const color = v >= 75 ? "hsl(var(--teal))" : v >= 55 ? "hsl(var(--info))" : v >= 35 ? "hsl(var(--warning))" : "hsl(var(--destructive))";
  return (
    <div className="flex flex-col items-center" data-testid={`score-ring-${label?.toLowerCase().replace(/\s/g, "-")}`}>
      <div className="relative" style={{ width: size, height: size }}>
        <svg width={size} height={size} className="-rotate-90">
          <circle cx={size/2} cy={size/2} r={r} stroke="hsl(var(--border))" strokeWidth="6" fill="none" />
          <circle cx={size/2} cy={size/2} r={r} stroke={color} strokeWidth="6" fill="none"
            strokeDasharray={c} strokeDashoffset={offset} strokeLinecap="round"
            style={{transition:"stroke-dashoffset 1s ease-out"}}
          />
        </svg>
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          <div className="data-large text-2xl sm:text-3xl leading-none">{v}</div>
          <div className="text-[10px] text-muted-foreground font-mono">/100</div>
        </div>
      </div>
      {label && <div className="text-[10px] sm:text-[11px] uppercase tracking-wider font-bold text-muted-foreground mt-3 text-center">{label}</div>}
    </div>
  );
}
